/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    KijinetaTag,
    KijinetaTagFromJSON,
    KijinetaTagFromJSONTyped,
    KijinetaTagToJSON,
} from './KijinetaTag';

/**
 * 
 * @export
 * @interface PopularKeywordsResponse
 */
export interface PopularKeywordsResponse {
    /**
     * 
     * @type {Array<KijinetaTag>}
     * @memberof PopularKeywordsResponse
     */
    data: Array<KijinetaTag>;
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof PopularKeywordsResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof PopularKeywordsResponse
     */
    message: string;
}

export function PopularKeywordsResponseFromJSON(json: any): PopularKeywordsResponse {
    return PopularKeywordsResponseFromJSONTyped(json, false);
}

export function PopularKeywordsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PopularKeywordsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(KijinetaTagFromJSON)),
        'status': json['status'],
        'message': json['message'],
    };
}

export function PopularKeywordsResponseToJSON(value?: PopularKeywordsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(KijinetaTagToJSON)),
        'status': value.status,
        'message': value.message,
    };
}

